<header>
  <h2>Derivar a Glass Talleres</h2>
  <h2 id="btnCerrar" mat-flat-button (click)="onClose()">X</h2>
</header>
<mat-dialog-content>
  <mat-tab-group class="glass-tabs" [(selectedIndex)]="selectedTabIndex" animationDuration="0ms">
    <mat-tab label="Siniestro">
      <form id="glassTalleres" #siniestroPanel class="tab-panel" [formGroup]="glassForm">
        <div class="gt-fila-boton">
          <div class="gt-campo">
            <label>Teléfono *</label>
            <input
              type="tel"
              matInput
              formControlName="telefono"
              maxlength="15"
              [class.gt-campo-invalido]="campoInvalido('telefono')"
            >
          </div>
          <div class="gt-campo">
            <label>Compañía *</label>
            <input
              type="text"
              matInput
              formControlName="compania"
              maxlength="100"
              [matAutocomplete]="autoCia"
              (focus)="onCompaniaFocus()"
            >
            <mat-autocomplete #autoCia="matAutocomplete" [displayWith]="displayCia" [autoActiveFirstOption]="false">
              <mat-option *ngFor="let opt of ciasFiltradas$ | async" [value]="opt">
                {{ (opt.nombre || '').trim() + ' ' + (opt.cliente || '').trim() }}
              </mat-option>
            </mat-autocomplete>
            <mat-progress-bar *ngIf="cargandoCias" mode="indeterminate"></mat-progress-bar>
          </div>
          <div class="gt-campo">
            <label>Matrícula *</label>
            <input
              type="text"
              matInput
              formControlName="matricula"
              maxlength="20"
              (input)="toUpperCaseMat($event)"
              [class.gt-campo-invalido]="campoInvalido('matricula')"
            >
            <mat-progress-bar *ngIf="buscando" mode="indeterminate"></mat-progress-bar>
          </div>
          <div class="gt-campo gt-campo-accion">
            <button
              type="button"
              class="btnCCOscuro"
              mat-flat-button
              (click)="buscarSiniestro()"
              [disabled]="buscando || guardando"
              [class.disabled]="buscando || guardando"
            >Buscar</button>
          </div>
        </div>
        <div class="gt-fila-boton">
          <div class="gt-campo">
            <label>Nombre *</label>
            <input
              type="text"
              matInput
              formControlName="nombre"
              maxlength="30"
              [class.gt-campo-invalido]="campoInvalido('nombre')"
            >
          </div>
          <div class="gt-campo">
            <label>Canal entrada *</label>
            <mat-select formControlName="canalEntrada" panelClass="glass-select-panel">
              <mat-option *ngFor="let opt of canalEntradaList" [value]="opt.value">{{ opt.label }}</mat-option>
            </mat-select>
          </div>
          <div class="gt-campo">
            <label>Código postal *</label>
            <input
              type="text"
              matInput
              formControlName="codigoPostal"
              maxlength="5"
              inputmode="numeric"
              (input)="soloNumerosCp($event)"
              [class.gt-campo-invalido]="campoInvalido('codigoPostal')"
            >
          </div>
          <div class="gt-campo gt-campo-accion">
            <button
              type="button"
              class="btnCCOscuro"
              mat-flat-button
              (click)="buscarTalleresPorCp()"
              [disabled]="buscandoTalleres || guardando"
              [class.disabled]="buscandoTalleres || guardando"
            >Buscar</button>
          </div>
        </div>
        <mat-progress-bar *ngIf="buscandoTalleres" mode="indeterminate"></mat-progress-bar>
        <div class="gt-fila-boton">
          <div class="gt-campo gt-campo-xl">
            <label>GT taller</label>
            <input type="text" matInput formControlName="gtTaller" maxlength="100">
          </div>
          <div class="gt-campo gt-campo-flex">
            <label>Daños *</label>
            <mat-select
              formControlName="danos"
              multiple
              panelClass="glass-danos-panel"
              class="danos-select"
              (selectionChange)="onDanosChange()"
            >
              <mat-select-trigger>
                <ul class="danos-bullets" *ngIf="getDanosLabels().length">
                  <li *ngFor="let label of getDanosLabels()">{{ label }}</li>
                </ul>
              </mat-select-trigger>
              <mat-option *ngFor="let opt of danosList" [value]="opt.value">{{ opt.label }}</mat-option>
            </mat-select>
          </div>
        </div>
      </form>
    </mat-tab>

    <mat-tab label="Incidencia">
      <form
        id="glassIncidencia"
        class="tab-panel tab-panel-incidencia"
        [formGroup]="incidenciaForm"
        [style.height.px]="incidenciaPanelHeight"
        [style.minHeight.px]="incidenciaPanelHeight"
      >
        <div class="gt-incidencia-layout">
          <div class="gt-incidencia-campos">
            <div class="gt-fila-boton">
              <div class="gt-campo gt-campo-md">
                <label>Matrícula *</label>
                <input
                  type="text"
                  matInput
                  formControlName="matricula"
                  maxlength="20"
                  (input)="toUpperCaseMatIncidencia($event)"
                  [class.gt-campo-invalido]="campoInvalidoIncidencia('matricula')"
                >
                <mat-progress-bar *ngIf="buscandoIncidencia" mode="indeterminate"></mat-progress-bar>
              </div>
              <div class="gt-campo gt-campo-accion">
                <button
                  type="button"
                  class="btnCCOscuro"
                  mat-flat-button
                  (click)="buscarSiniestroParaIncidencia()"
                  [disabled]="buscandoIncidencia || guardando"
                  [class.disabled]="buscandoIncidencia || guardando"
                >Buscar</button>
              </div>
              <input type="hidden" formControlName="otralarsa">
            </div>
            <div class="gt-fila-boton">
              <div class="gt-campo gt-campo-lg">
                <label>Incidencia *</label>
                <mat-select
                  formControlName="incidencia"
                  panelClass="glass-select-panel"
                  (selectionChange)="onIncidenciaChange()"
                >
                  <mat-option *ngFor="let opt of incidenciaList" [value]="opt">{{ opt }}</mat-option>
                </mat-select>
              </div>
            </div>
            <div class="gt-fila-boton" *ngIf="esIncidenciaOtros()">
              <div class="gt-campo">
                <label>Detalle incidencia</label>
                <textarea matInput formControlName="incidenciaOtros" maxlength="230" rows="3"></textarea>
              </div>
            </div>
          </div>

          <div class="gt-resumen-siniestro" *ngIf="resumenSiniestroIncidencia as resumen">
            <div class="gt-resumen-fila">
              <span class="gt-resumen-label">Nombre</span>
              <span class="gt-resumen-valor">{{ resumen.nombre }}</span>
            </div>
            <div class="gt-resumen-fila">
              <span class="gt-resumen-label">Estado</span>
              <span class="gt-resumen-valor">{{ resumen.estado }}</span>
            </div>
            <div class="gt-resumen-fila">
              <span class="gt-resumen-label">Fecha cita</span>
              <span class="gt-resumen-valor">{{ resumen.fecha_cita }}</span>
            </div>
          </div>
        </div>
      </form>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<mat-progress-bar *ngIf="guardando" mode="indeterminate"></mat-progress-bar>
<mat-dialog-actions align="center" class="acciones-dialogo">
  <button type="button" class="btnCCOscuro btn-dialogo" mat-flat-button [mat-dialog-close]="true" [disabled]="guardando">Cancelar</button>
  <button type="button" class="btnCCNewOscuro btn-dialogo" mat-flat-button (click)="onGuardarClick()" [disabled]="guardando">Guardar</button>
</mat-dialog-actions>
